import styles from './styles/Styles.module.css';

export const IconButton = ({ children, variant = 'round', ...rest }) => (
  <button
    className={`${styles.button} ${
      variant === 'round' ? styles.round_variant : styles.default
    }`}
    {...rest}
  >
    {children}
  </button>
);
